import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as CommodityActions from '../_actions/commodity';
import { Commodity } from '../_models';

export interface CommodityState extends EntityState<Commodity> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Commodity> = createEntityAdapter<Commodity>();

const initialState: CommodityState = adapter.getInitialState({
  loading: false,
  error: null,
});

const commodityReducer = createReducer(
  initialState,

  on(CommodityActions.loadCommodities, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CommodityActions.loadCommoditiesSuccess, (state, { commodities }) =>
    adapter.setAll(commodities, { ...state, loading: false })
  ),

  on(CommodityActions.loadCommoditiesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CommodityActions.addCommoditySuccess, (state, { commodity }) =>
    adapter.addOne(commodity, state)
  ),

  on(CommodityActions.updateCommoditySuccess, (state, { commodity }) =>
    adapter.upsertOne(commodity, state)
  ),

  on(CommodityActions.deleteCommoditySuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    CommodityActions.addCommodityFailure,
    CommodityActions.updateCommodityFailure,
    CommodityActions.deleteCommodityFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: CommodityState | undefined, action: Action) {
  return commodityReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
